import { getPlpTagFromUrl } from '@/features/plp/utils/plpUrl';

/**
 * Full browse `tags` string from a jewellery PLP/apply URL path (hyphen-joined),
 * including **all** path segments after `/jewellery/` or `/jewellery/filter/`.
 *
 * Used by new home recommended browse when committing facet apply URLs.
 * `getPlpTagFromUrl` only returns the last segment; multi-segment facet paths need this shape.
 */
export function getJewelleryBrowseTagStringFromApplyPath(pathname: string): string {
  const path = pathname.split('?')[0].replace(/\.html?$/i, '');
  if (path === '/jewellery' || path === '/jewellery/') return 'jewellery';

  if (path.startsWith('/jewellery/filter/')) {
    const rest = path.slice('/jewellery/filter/'.length).replace(/^\/+|\/+$/g, '');
    if (!rest) return 'jewellery';
    return rest.split('/').filter(Boolean).join('-');
  }

  if (path.startsWith('/jewellery/')) {
    const rest = path.slice('/jewellery/'.length).replace(/^\/+|\/+$/g, '');
    if (!rest) return 'jewellery';
    return rest.split('/').filter(Boolean).join('-');
  }

  return getPlpTagFromUrl(pathname);
}
